const initialState = {
    odata: [],
    imgdata:[],
    updatedata:[],
    countrydata:[],
    docdata:[],
    dataview:[],
    };
  
  const OrgProfileReducers = (state = initialState, action: any) => {
    switch (action.type) {
      case 'FETCH_DATA_SUCCESS':
        return { ...state, odata: action.payload };
        case 'FETCH_IMAGE_DATA_SUCCESS':
            return { ...state, imgdata: action.payload };
            case 'FETCH_UPDATE_DATA_SUCCESS':
            return { ...state, updatedata: action.payload };
            case 'FETCH_COUNTRY_DATA_SUCCESS':
            return { ...state, countrydata: action.payload };
            case 'FETCH_DOC_DATA_SUCCESS':
              return { ...state, docdata: action.payload };
              case 'FETCH_VIEW_DATA_SUCCESS':
              return { ...state, dataview: action.payload };
      default:
        return state;
    }
  };
  
  export default OrgProfileReducers;
  
  